(function(){
  var TOAST_KEY = 'fwbs_app_toast_dismissed';
  if (sessionStorage.getItem(TOAST_KEY)) return;

  function getAppUrl() {
    var ua = navigator.userAgent || '';
    if (/android/i.test(ua)) {
      return 'https://play.google.com/store/apps/details?id=com.fwbarbersupply.app';
    }
    return 'https://apps.apple.com/us/app/fw-barber-supply/id6761860615';
  }

  function getButtonLabel() {
    var ua = navigator.userAgent || '';
    if (/android/i.test(ua)) {
      return 'GET ON GOOGLE PLAY';
    }
    if (/iphone|ipad|ipod/i.test(ua)) {
      return 'GET ON APP STORE';
    }
    return 'DOWNLOAD FREE';
  }

  function injectToast() {
    var css = document.createElement('style');
    css.textContent = ''
      + '@import url(\'https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Fraunces:ital,opsz,wght@0,9..144,400;1,9..144,400&family=JetBrains+Mono:wght@400;500&display=swap\');'
      + '.fwbs-toast-overlay{position:fixed;bottom:24px;right:24px;z-index:9999;pointer-events:none;font-family:"JetBrains Mono","Courier New",monospace;}'
      + '.fwbs-toast-overlay *{box-sizing:border-box;margin:0;padding:0;}'
      + '.fwbs-toast{pointer-events:auto;position:relative;width:380px;max-width:calc(100vw - 32px);background:#EEEDE7;border:1px solid #111;box-shadow:0 12px 40px rgba(17,17,17,0.18);overflow:hidden;transform:translateY(120%);opacity:0;transition:transform 0.5s cubic-bezier(0.16,1,0.3,1),opacity 0.4s ease;}'
      + '.fwbs-toast--visible{transform:translateY(0)!important;opacity:1!important;}'
      + '.fwbs-toast--hiding{transform:translateY(120%)!important;opacity:0!important;}'
      + '.fwbs-toast-accent{height:3px;background:#E42425;}'
      + '.fwbs-toast-body{padding:18px 20px 16px;display:flex;gap:14px;align-items:flex-start;}'
      + '.fwbs-toast-icon{flex-shrink:0;width:44px;height:44px;overflow:hidden;border-radius:10px;}'
      + '.fwbs-toast-icon img{border-radius:10px;}'
      + '.fwbs-toast-icon img{width:100%;height:100%;object-fit:cover;display:block;border-radius:10px;}'
      + '.fwbs-toast-text{flex:1;min-width:0;}'
      + '.fwbs-toast-label{display:block;font-family:"JetBrains Mono","Courier New",monospace;font-size:10px;font-weight:500;letter-spacing:0.18em;text-transform:uppercase;color:#5A5853;margin-bottom:6px;}'
      + '.fwbs-toast-title{font-family:"Bebas Neue","Oswald",Impact,sans-serif;font-size:24px;line-height:1.05;letter-spacing:0.02em;color:#111;margin-bottom:6px;}'
      + '.fwbs-toast-desc{font-family:"Fraunces",Georgia,serif;font-style:italic;font-size:13px;line-height:1.45;color:#3A3833;margin-bottom:14px;}'
      + '.fwbs-toast-actions{display:flex;align-items:center;gap:10px;}'
      + '.fwbs-toast-actions a{font-family:"Bebas Neue","Oswald",Impact,sans-serif;font-size:13px;font-weight:400;letter-spacing:0.08em;text-transform:uppercase;color:#EEEDE7;background:#E42425;padding:10px 18px;text-decoration:none;display:inline-block;line-height:1;transition:background 0.2s ease;border:0;}'
      + '.fwbs-toast-actions a:hover{background:#C81C1D;}'
      + '.fwbs-toast-actions button{font-family:"JetBrains Mono","Courier New",monospace;font-size:11px;font-weight:400;letter-spacing:0.1em;text-transform:uppercase;color:#5A5853;background:none;border:none;cursor:pointer;padding:8px 4px;transition:color 0.2s ease;line-height:1;}'
      + '.fwbs-toast-actions button:hover{color:#111;}'
      + '.fwbs-toast-close{position:absolute;top:10px;right:10px;width:26px;height:26px;background:transparent;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:opacity 0.2s ease;padding:0;opacity:0.6;}'
      + '.fwbs-toast-close:hover{opacity:1;}'
      + '.fwbs-toast-close svg{width:12px;height:12px;stroke:#111;stroke-width:1.5;fill:none;}'
      + '@media(max-width:480px){.fwbs-toast-overlay{bottom:16px;right:16px;left:16px;}.fwbs-toast{width:100%;}.fwbs-toast-title{font-size:22px;}}';
    document.head.appendChild(css);

    var html = ''
      + '<div class="fwbs-toast-overlay" id="fwbsToastOverlay" style="display:none;">'
      + '<div class="fwbs-toast" id="fwbsToast">'
      + '<div class="fwbs-toast-accent"></div>'
      + '<button class="fwbs-toast-close" id="fwbsToastClose" aria-label="Close">'
      + '<svg viewBox="0 0 14 14"><line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/></svg>'
      + '</button>'
      + '<div class="fwbs-toast-body">'
      + '<div class="fwbs-toast-icon">'
      + '<img src="https://cdn.shopify.com/s/files/1/0686/6019/9615/files/icon.png?v=1776022966" alt="FW Barber Supply App">'
      + '</div>'
      + '<div class="fwbs-toast-text">'
      + '<span class="fwbs-toast-label">— NOW ON iOS &amp; ANDROID</span>'
      + '<div class="fwbs-toast-title">GET THE FWBS APP</div>'
      + '<p class="fwbs-toast-desc">Shop, track orders, and request deliveries &mdash; all in one app.</p>'
      + '<div class="fwbs-toast-actions">'
      + '<a href="' + getAppUrl() + '" target="_blank" rel="noopener">' + getButtonLabel() + '</a>'
      + '<button id="fwbsToastDismissText">NOT NOW</button>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '</div>';

    document.body.insertAdjacentHTML('beforeend', html);

    var overlay = document.getElementById('fwbsToastOverlay');
    var toast = document.getElementById('fwbsToast');

    function dismiss() {
      toast.classList.remove('fwbs-toast--visible');
      toast.classList.add('fwbs-toast--hiding');
      sessionStorage.setItem(TOAST_KEY, '1');
      setTimeout(function(){ overlay.style.display = 'none'; }, 500);
    }

    document.getElementById('fwbsToastClose').addEventListener('click', dismiss);
    document.getElementById('fwbsToastDismissText').addEventListener('click', dismiss);

    overlay.style.display = 'block';
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        toast.classList.add('fwbs-toast--visible');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(injectToast, 3000); });
  } else {
    setTimeout(injectToast, 3000);
  }
})();